export const Bundler3 = [
  'function multicall((address to, bytes data, uint256 value, bool skipRevert, bytes32 callbackHash)[] bundle)',
  'function reenter((address to, bytes data, uint256 value, bool skipRevert, bytes32 callbackHash)[] bundle)'
]
